/**
 * Configuration centralisée pour l'API
 */
const getApiUrl = () => {
  // If accessing from an IP address or hostname (not localhost), use the same host for API
  const currentHost = window.location.hostname;
  const isLocalhost = currentHost === 'localhost' || currentHost === '127.0.0.1';

  let baseUrl = '';

  if (process.env.NODE_ENV === 'development' && !isLocalhost) {
    // When accessing via IP in development, use the same IP for the backend
    console.log('ENV IS', process.env.REACT_APP_BACKEND_URL );

    baseUrl = process.env.REACT_APP_BACKEND_URL || `http://${currentHost}:3002`;
    // baseUrl = `http://${currentHost}:3002`;
  } else {
    // Default behavior
    baseUrl = process.env.REACT_APP_BACKEND_URL || '';

    // baseUrl = process.env.NODE_ENV === 'development'
    //   ? "http://localhost:3002"
    //   : process.env.REACT_APP_BACKEND_URL || "";
  }

  // Remove trailing slash if present
  return baseUrl.replace(/\/$/, '');
};

export const API_CONFIG = {
  baseURL: getApiUrl(),
  timeout: 30000,
} as const;

// Export de l'URL pour compatibilité
export const API_URL = API_CONFIG.baseURL;
